import storaenso from "../assets/images/companies/storaenso.png";
import zdraveobedy from "../assets/images/companies/zdraveobedy.png";
import okin from "../assets/images/companies/okin.png";
import hyverr from "../assets/images/companies/hyverr.png";

import zdraveobedy_1 from "../assets/images/projects/zdraveobedy_1.png";
import zdraveobedy_2 from "../assets/images/projects/zdraveobedy_2.png";
import zdraveobedy_3 from "../assets/images/projects/zdraveobedy_3.png";
import zdraveobedy_4 from "../assets/images/projects/zdraveobedy_4.png";
import zdraveobedy_5 from "../assets/images/projects/zdraveobedy_5.png";
import eatmeshark_1 from "../assets/images/projects/eatmeshark_1.png";
import eatmeshark_2 from "../assets/images/projects/eatmeshark_2.png";
import eatmeshark_3 from "../assets/images/projects/eatmeshark_3.png";
import spsei_marketplace_1 from "../assets/images/projects/spsei_marketplace_1.png";
import spsei_marketplace_2 from "../assets/images/projects/spsei_marketplace_2.png";
import spsei_marketplace_3 from "../assets/images/projects/spsei_marketplace_3.png";
import spsei_marketplace_4 from "../assets/images/projects/spsei_marketplace_4.png";
import fitsklep_1 from "../assets/images/projects/fitsklep_1.png";
import fitsklep_2 from "../assets/images/projects/fitsklep_2.png";
import fitsklep_3 from "../assets/images/projects/fitsklep_3.png";
import fitsklep_4 from "../assets/images/projects/fitsklep_4.png";
import fitsklep_5 from "../assets/images/projects/fitsklep_5.png";
import fitsklep_6 from "../assets/images/projects/fitsklep_6.png";
import soks_1 from "../assets/images/projects/soks_1.png";
import soks_2 from "../assets/images/projects/soks_2.png";
import soks_3 from "../assets/images/projects/soks_3.png";
import soks_4 from "../assets/images/projects/soks_4.png";

const navbar = {
    links: [
        {
            title: "Skills",
            id: "skills"
        },
        {
            title: "Experience",
            id: "experience"
        },
        {
            title: "Projects",
            id: "projects"
        },
        {
            title: "Contact",
            id: "contact"
        },
    ]
};

const hero = {
    text: "Hello, I'm Peter",
    subtext: "Frontend & Backend Web Developer"
};

const socials = {
    github: {
        link: "https://github.com/p0bt",
    },
    linkedin: {
        link: "http://linkedin.com/in/peter-butora-developer"
    }
};

const skills = {
    heading: "Skills",
    text: "I focus on website and web application development. I mainly enjoy Frontend (React), but I'm not afraid of backend in PHP/Java/Node.js either.",
    tools: [
        {
            title: "GIT (Github, Azure DevOps...)",
            level: 80
        },
        {
            title: "Shopify (+ .liquid template editing)",
            level: 40
        },
        {
            title: "Shoptet (+ Basic Plan hacking with custom CSS / Javascript)",
            level: 40
        },
        {
            title: "Wordpress",
            level: 40
        },
        {
            title: "Linux Debian/Ubuntu (CLI, simple shell scripts)",
            level: 40
        },
        {
            title: "Powerpoint, Excel, Word",
            level: 75
        },
        {
            title: "Photoshop, Canva, Capcut",
            level: 40
        }
    ],
    technologies: [
        {
            title: "Vanilla JavaScript + jQuery, Node.js",
            level: 80
        },
        {
            title: "React, TypeScript",
            level: 65
        },
        {
            title: "JAVA (Springboot), Freemaker",
            level: 60
        },
        {
            title: "PHP (OOP, MVC), CODEIGNITER4",
            level: 75
        },
        {
            title: ".NET C#",
            level: 20
        },
        {
            title: "MySQL",
            level: 60
        },
        {
            title: "HTML",
            level: 100
        },
        {
            title: "CSS, Bootstrap 4/5, Tailwind css",
            level: 70
        }
    ]
};

const experience = {
    heading: "My Experience",
    subtext: "YEAR 2021 - " + new Date().getFullYear(),
    list: [
        {
            title: "Full-stack Developer (Full-time)",
            company_name: "Hyverr s.r.o",
            icon: hyverr,
            iconBg: "#fff3d4",
            date: "September 2024 - Present",
            points: [
                "Development of backend REST API using Java Spring Boot.",
                "Frontend development using React and Redux.",
                "Handling client requests and resolving JIRA tickets.",
                "Preparing and publishing releases for a dockerized application running in a Linux environment.",
            ],
        },
        {
            title: "RMP Developer (Full-time)",
            company_name: "OKIN Process a.s. (IOTOR)",
            icon: okin,
            iconBg: "#ffffff",
            date: "September 2023 - August 2024",
            points: [
                "Development of web applications for clients using the RMP platform.",
                "Creating and configuring widgets using drag & drop system and JavaScript logic.",
                "Working in a team and communicating with English-speaking clients.",
                "Technologies: RMP Platform, JavaScript, jQuery, HTML, CSS, Freemarker.",
            ],
        },
        {
            title: "RMP Developer (Part-time)",
            company_name: "OKIN Process a.s. (IOTOR)",
            icon: okin,
            iconBg: "#ffffff",
            date: "March 2022 - August 2023",
            points: [
                "Development of web applications for clients using the RMP platform.",
                "Creating and configuring widgets using drag & drop system and JavaScript logic.",
                "Working in a team environment.",
                "Technologies: RMP Platform, JavaScript, jQuery, HTML, CSS, Freemarker.",
            ],
        },
        {
            title: "PHP Developer (Part-time)",
            company_name: "OKIN Process a.s.",
            icon: okin,
            iconBg: "#ffffff",
            date: "October 2021 - March 2022",
            points: [
                "Development of web applications for both clients and internal use.",
                "Working in a team environment.",
                "Technologies: PHP (CodeIgniter 4), JavaScript, jQuery, HTML, CSS, Bootstrap.",
            ],
        },
        {
            title: "PHP Developer (Contract)",
            company_name: "zdraveobedy.cz",
            icon: zdraveobedy,
            iconBg: "#daecb4",
            date: "July 2021",
            points: [
                "Development of a web application for a local food delivery company.",
                "Technologies: PHP (CodeIgniter 4), JavaScript, jQuery, HTML, CSS, Comgate API",
            ],
        },
        {
            title: "Selenium Tester (14-day Internship)",
            company_name: "Storaenso",
            icon: storaenso,
            iconBg: "#d7c5f4",
            date: "May 2021",
            points: [
                "Short-term internship during school.",
                "Writing Selenium tests for an online shop to verify application functionality.",
                "Technologies: .NET C#, Selenium.",
            ],
        },
    ]
}

const projects = {
    heading: "Projects",
    subtext: "MY WORK",
    list: [
        {
            title: "Soks.cz",
            date: "2025 - 2026",
            description: "My E-commerce subscription store with a fully custom Shopify design. Developed unique sections using liquid code and AI.",
            images: [
                soks_1,
                soks_2,
                soks_3,
                soks_4
            ],
            tags: ["Shopify", ".liquid", "AI", "Custom"],
            links: [
                {
                    text: "Live website",
                    url: "https://soks.cz/",
                },
                {
                    text: "Page Speed Insights (SEO)",
                    url: "https://pagespeed.web.dev/analysis/https-soks-cz/tyzcnkuiw9?form_factor=desktop"
                }
            ],
        },
        {
            title: "Fitsklep.cz",
            date: "2025",
            description: "Reservation system for a private fitness center, including an admin dashboard to manage bookings. Frontend developed in React with AI assistance. Then made myself final touches, and bug fixes.",
            images: [
                fitsklep_1,
                fitsklep_2,
                fitsklep_3,
                fitsklep_4,
                fitsklep_5,
                fitsklep_6,
            ],
            tags: ["React", "PostgreSQL (Supabase)", "AI", "Comgate API"],
            links: [
                {
                    text: "Live website",
                    url: "https://fitsklep.cz/",
                }
            ],
        },
        {
            title: "SPŠEI Marketplace",
            date: "2022 - 2023",
            description: "Graduation project - a responsive web marketplace for students to buy and sell study materials. Built on a custom PHP MVC core with real-time features.",
            images: [
                spsei_marketplace_1,
                spsei_marketplace_2,
                spsei_marketplace_3,
                spsei_marketplace_4,
            ],
            tags: ["PHP", "MVC", "MySQL", "JavaScript", "WebSocket"],
            links: [
                {
                    text: "GitHub - Source Code",
                    url: "https://github.com/p0bt/spsei_marketplace_shared",
                },
                {
                    text: "GitHub - Documentation",
                    url: "https://github.com/p0bt/spsei_marketplace_docs_shared",
                }
            ],
        },
        {
            title: "Zdraveobedy.cz",
            date: "2021",
            description: "Web application for a local food delivery service with ordering system and admin management.",
            images: [
                zdraveobedy_3,
                zdraveobedy_2,
                zdraveobedy_4,
                zdraveobedy_5,
                zdraveobedy_1
            ],
            tags: ["PHP", "CodeIgniter 4", "MySQL", "JavaScript", "HTML", "CSS", "Comgate API"],
            links: [
                {
                    text: "Live website",
                    url: "https://zdraveobedy.cz/uvod",
                }
            ],
        },
        {
            title: "EatMeShark",
            date: "2020",
            description: "A small free desktop game developed in Unity using .NET C#. Supports local split-screen multiplayer and multiple game modes.",
            images: [
                eatmeshark_1,
                eatmeshark_2,
                eatmeshark_3,
            ],
            tags: ["Unity engine", "C#", "Blender", "Photoshop"],
            links: [
                {
                    text: "Play on itch.io",
                    url: "https://azurax.itch.io/eatmeshark",
                }
            ],
        }
    ]
};

const otherProjects = [
    {
        title: "Stachstudio.cz (2020 / 2021)",
        url: "https://stachstudio.cz/",
        description: "WordPress website for a movie studio, featuring heavy use of video and image content as requested by the client."
    },
    {
        title: "Farma-kondziolka.cz (2020 / 2021)",
        url: "https://farma-kondziolka.cz/",
        description: "WordPress website for a local farm. Content is fully managed by the client."
    }
];

export { navbar, hero, socials, skills, experience, projects, otherProjects };